<template>
  <div id="about">
    <section class="section">
    <div style="width:80%; margin:auto;">
      <div class="has-text-centered">
        <span style="margin-bottom:30px" class="underline heading is-size-2 w300">About Me</span>
        <p class="is-size-5">Computer Engineering Undergraduate inspired to learn more and dedicated to work effectively.
          Loves UI/UX projects and Android App Development</p>
      </div>
    </div>   
  </section>
  </div>
</template>

<script>

export default {
  data() {
    return {
      
    }
  }
}
</script>


<style scoped>


</style>
